import { render, staticRenderFns } from "./Intermission.vue?vue&type=template&id=0ffffa94&scoped=true&"
import script from "./Intermission.vue?vue&type=script&lang=ts&"
export * from "./Intermission.vue?vue&type=script&lang=ts&"
import style0 from "./Intermission.vue?vue&type=style&index=0&id=0ffffa94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ffffa94",
  null
  
)

export default component.exports